'use strict';

var React = require('react');

var SvgWearableMajor = function SvgWearableMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3v2.5a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-2.5a3 3 0 0 0 3-3v-1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1v-1a3 3 0 0 0-3-3v-2.5a1.5 1.5 0 0 0-1.5-1.5h-5a1.5 1.5 0 0 0-1.5 1.5v2.5zm2 0v-2h4v2h-4zm4 12v2h-4v-2h4zm-6-10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-8z"
  }));
};

exports.SvgWearableMajor = SvgWearableMajor;
